{
  "loading": "Načítání...",
  "placeholder": "Vyberte vhodnou možnost..."
}